/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close-modal': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 14.121l-6.44 6.44-2.12-2.122L9.878 12l-6.44-6.44 2.122-2.12L12 9.878l6.44-6.44 2.12 2.122L14.122 12l6.44 6.44-2.122 2.12L12 14.122z" _fill="#7E8994" fill-rule="evenodd"/>'
  }
})
